'use strict'

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject'

  $urlRouterProvider.when('/deviceconfigs', '/deviceconfigs/list')

  $stateProvider
    .state('deviceconfigs', {
      url: '/deviceconfigs',
      template: require('./deviceconfigs.html'),
      authenticate: true
    })
    .state('deviceconfigs.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'DeviceConfigsListController',
      controllerAs: 'dcListCtrl',
      authenticate: true
    })
    .state('deviceconfigs.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'DeviceConfigsShowController',
      controllerAs: 'dcShowCtrl',
      authenticate: true
    })
    .state('deviceconfigs.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'DeviceConfigsAddController',
      controllerAs: 'dcAddCtrl',
      authenticate: true
    })
    .state('deviceconfigs.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'DeviceConfigsEditController',
      controllerAs: 'dcEditCtrl',
      authenticate: true
    })
}



// WEBPACK FOOTER //
// ./client/app/deviceconfigs/deviceconfigs.routes.js